import React, { useState, useEffect, useRef } from "react";
import { FaStar, FaQuoteLeft, FaQuoteRight, FaArrowLeft, FaArrowRight, FaUserCheck, FaRegHeart, FaThumbsUp } from "react-icons/fa";
import "../styles/TestimonialsSection.css";
import aboutImg from "../assets/dite.jpg";

const TestimonialsSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      name: "Rajesh Sharma",
      location: "Delhi",
      rating: 5,
      text: "Indian Detective Agency provided exceptional service for my pre-marriage investigation. Their team was professional, discreet, and delivered accurate results. Highly recommended!",
      image: aboutImg,
      role: "Business Owner",
      date: "March 2024",
    },
    {
      id: 2,
      name: "Priya Mehta",
      location: "Mumbai",
      rating: 5,
      text: "I hired them for corporate due diligence, and they exceeded my expectations. The detailed report helped us make an informed business decision. Truly professional!",
      image: aboutImg,
      role: "Corporate Executive",
      date: "February 2024",
    },
    {
      id: 3,
      name: "Amit Kumar",
      location: "Bangalore",
      rating: 5,
      text: "Excellent service for NRI matrimonial fraud investigation. They handled everything professionally and kept me updated throughout the process. Thank you!",
      image: aboutImg,
      role: "NRI Client",
      date: "January 2024",
    },
    {
      id: 4,
      name: "Neha Singh",
      location: "Pune",
      rating: 5,
      text: "The team was extremely professional and understanding. They handled my case with utmost sensitivity and delivered results beyond my expectations.",
      image: aboutImg,
      role: "Legal Professional",
      date: "December 2023",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
      }, 6000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);

  const nextTestimonial = () => {
    setIsAutoPlaying(false);
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const prevTestimonial = () => {
    setIsAutoPlaying(false);
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  return (
    <section className="testimonials-premium" ref={sectionRef}>
      {/* Animated Background */}
      <div className="testimonials-premium-bg">
        <div className="bg-gradient"></div>
        <div className="bg-particles">
          {[...Array(30)].map((_, i) => (
            <div key={i} className="particle" style={{ animationDelay: `${i * 0.3}s`, left: `${Math.random() * 100}%` }}></div>
          ))}
        </div>
      </div>

      <div className="testimonials-premium-container">
        {/* Header Section */}
        <div className="testimonials-premium-header">
          <div className="header-floating">
            <FaUserCheck className="floating-icon" />
          </div>
          <span className="premium-badge">
            <FaRegHeart className="badge-heart" />
            Client Testimonials
          </span>
          <h2 className="premium-title">
            What Our <span className="title-gradient"> Clients Say</span>
            
          </h2>
          <div className="title-decoration">
            <span className="decoration-line"></span>
            <span className="decoration-dot"></span>
            <span className="decoration-line"></span>
          </div>
          <p className="premium-subtitle">
            Don't just take our word for it. Here's what our valued clients have to say about their experience with us.
          </p>
        </div>

        {/* Main Testimonial Card */}
        <div className="testimonial-premium-wrapper">
          <button className="nav-btn prev-btn" onClick={prevTestimonial}>
            <FaArrowLeft />
          </button>

          <div className="testimonial-premium-card">
            <div className="card-background-pattern"></div>
            <div className="card-glow"></div>
            
            <div className="testimonial-content-wrapper">
              <div className="quote-icon-left">
                <FaQuoteLeft />
              </div>
              
              <p className="testimonial-premium-text">
                "{testimonials[currentTestimonial].text}"
              </p>
              
              <div className="testimonial-rating">
                {[...Array(5)].map((_, i) => (
                  <FaStar 
                    key={i} 
                    className={`rating-star ${i < testimonials[currentTestimonial].rating ? "filled" : ""}`} 
                  />
                ))}
                <span className="rating-text">Excellent Service</span>
              </div>
              
              <div className="testimonial-author-premium">
                <div className="author-avatar">
                  <img src={testimonials[currentTestimonial].image} alt={testimonials[currentTestimonial].name} />
                  <div className="avatar-ring"></div>
                </div>
                <div className="author-details">
                  <h4>{testimonials[currentTestimonial].name}</h4>
                  <p className="author-role">{testimonials[currentTestimonial].role}</p>
                  <div className="author-meta">
                    <span className="author-location">{testimonials[currentTestimonial].location}</span>
                    <span className="author-date">{testimonials[currentTestimonial].date}</span>
                  </div>
                </div>
              </div>
              
              <div className="trust-badge">
                <FaThumbsUp />
                <span>Verified Review</span>
              </div>
            </div>
            
            <div className="quote-icon-right">
              <FaQuoteRight />
            </div>
          </div>

          <button className="nav-btn next-btn" onClick={nextTestimonial}>
            <FaArrowRight />
          </button>
        </div>

        {/* Testimonial Indicators */}
        <div className="testimonial-indicators">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`indicator ${currentTestimonial === index ? "active" : ""}`}
              onClick={() => {
                setIsAutoPlaying(false);
                setCurrentTestimonial(index);
                setTimeout(() => setIsAutoPlaying(true), 10000);
              }}
            >
              <span className="indicator-number">0{index + 1}</span>
              <div className="indicator-line"></div>
            </button>
          ))}
        </div>

        {/* Stats Section */}
        <div className="testimonial-stats-premium">
          <div className="stat-item">
            <span className="stat-number">500+</span>
            <span className="stat-label">Happy Clients</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">98%</span>
            <span className="stat-label">Satisfaction Rate</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">4.9/5</span>
            <span className="stat-label">Average Rating</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;